import EtablissementSummary from '@/generated/controls/etablissement/EtablissementSummary.vue';
import Etablissement from '@/generated/classes/Etablissement';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementSummary,
    methods: {
        getDisplay(etablissement: Etablissement): string {
            return etablissement.alias == '' ? etablissement.nom : etablissement.alias;
        }
    }
})
